import React, { useEffect } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { fetchSubmissionData } from './actions';

const withSubmissionData = (WrappedComponent) => (props) => {
  useEffect(() => {
    const assignmentId = get(
      props,
      'params.ppcPartId',
      get(props, 'assignment.id', null),
    );

    if (assignmentId) {
      props.fetchSubmissionData(assignmentId);
    }
  }, [props.params, props.assignment]);

  return <WrappedComponent {...props} />;
};

const mapStateToProps = (state) => ({
  submissionData: state.submissionData.data,
});

const mapDispatchToProps = {
  fetchSubmissionData,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withSubmissionData,
);
